import { sectionRenderer } from '@theme/section-renderer';

const catalog = document.getElementById('ss26-catalog') || document.getElementById('basic-catalog') || document.getElementById('active-catalog');
const source = document.body.dataset.collectionSource;
if (catalog) {
  let frame;
  const updateHeader = () => {
    frame = null;
    const chrome = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--geh-chrome')) || 0;
    const active = catalog.getBoundingClientRect().top <= chrome + 1;
    // Contain only the landing-page navigation visually. Its geometry and the
    // catalog header's existing switching threshold stay unchanged.
    const hero = document.getElementById('ge-new') || document.getElementById('ge-basic') || document.getElementById('ge-active');
    const navigation = document.querySelector('.geh-home-nav');
    if (hero && navigation) {
      const bounds = navigation.getBoundingClientRect();
      const visibleHeight = Math.max(0, hero.getBoundingClientRect().bottom - bounds.top - 12);
      navigation.style.setProperty('--ss26-nav-visible-height', `${visibleHeight}px`);
      navigation.toggleAttribute('data-ss26-nav-clipped', visibleHeight < bounds.height);
    }
    if (document.body.hasAttribute('data-gch-catalog-active') !== active) {
      document.body.toggleAttribute('data-gch-catalog-active', active);
      document.dispatchEvent(new Event('giesto:catalog-header-change'));
    }
  };
  const scheduleHeader = () => { if (!frame) frame = requestAnimationFrame(updateHeader); };
  window.addEventListener('scroll', scheduleHeader, {passive:true,capture:true});
  window.addEventListener('resize', scheduleHeader, {passive:true});
  const navigation = document.querySelector('.geh-home-nav');
  if (navigation) new ResizeObserver(scheduleHeader).observe(navigation);
  updateHeader();

}

if (catalog && source) {
  const sourcePath = new URL(source, location.origin).pathname;
  for (const link of catalog.querySelectorAll('a[href]')) {
    const url = new URL(link.getAttribute('href'), location.origin);
    if (url.pathname === sourcePath) {
      url.pathname = location.pathname;
      link.href = url.href;
    }
  }
  // Page lookup objects do not expose live collection facets. Use the actual
  // collection response for filters, sorting and shared or reloaded URL state.
  const refresh = async (cache = true, preserveStory = false) => {
    catalog.setAttribute('aria-busy', 'true');
    try {
      await sectionRenderer.renderSection('giesto-store-collection', {cache, preserveStory});
      const current = catalog.querySelector('giesto-store-collection');
      const selectedView = current?.dataset.gacView || 'stories';
      const control = current?.querySelector(`[data-gac-view-option][value="${selectedView}"]`);
      if (control) {
        control.checked = true;
        control.dispatchEvent(new Event('change', {bubbles:true}));
      }
      catalog.dataset.ready = 'true';
    } catch (error) {
      console.error('New Season collection could not refresh', error);
      const fallback = new URL(source, location.origin);
      fallback.search = location.search;
      const notice = document.createElement('a');
      notice.href = fallback.href;
      notice.textContent = document.documentElement.lang === 'tr' ? 'Filtrelenmiş ürünleri görüntüle' : 'View filtered products';
      catalog.querySelector('giesto-store-collection')?.prepend(notice);
    } finally {
      catalog.removeAttribute('aria-busy');
    }
  };
  window.addEventListener('popstate', () => refresh());
  const query = new URLSearchParams(location.search);
  const changesProducts = [...query.keys()].some(key => key === 'sort_by' || key === 'page' || key.startsWith('filter.'));
  if (changesProducts) {
    refresh(false);
  } else {
    // The page already contains the unfiltered products. Give the campaign
    // image priority over a second full document needed only for live facets.
    const hero = document.querySelector('#ge-new img');
    const listeners = new AbortController();
    let started = false;
    let timer;
    const start = () => {
      if (started) return;
      started = true;
      clearTimeout(timer);
      listeners.abort();
      refresh(false, true);
    };
    const onScroll = () => { if (catalog.getBoundingClientRect().top < innerHeight) start(); };
    const options = { once: true, signal: listeners.signal };
    catalog.addEventListener('pointerdown', start, options);
    catalog.addEventListener('focusin', start, options);
    window.addEventListener('scroll', onScroll, { passive: true, capture: true, signal: listeners.signal });
    hero?.addEventListener('load', start, options);
    hero?.addEventListener('error', start, options);
    timer = setTimeout(start, 8000);
    if (!hero || hero.complete) start();
  }
}
